import type { ReactNode, SVGProps } from "react";

export function ArrowTailUpIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_220_188)">
				<path
					d="M7 11.0833L7 2.91658"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
				<path
					d="M3.5 6.41675L7 2.91675"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
				<path
					d="M10.5 6.41675L7 2.91675"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
			</g>
			<defs>
				<clipPath id="clip0_220_188">
					<rect fill="white" height="14" transform="matrix(-1 0 0 -1 14 14)" width="14" />
				</clipPath>
			</defs>
		</svg>
	);
}
